<div
  class="c-golden-bomb"
  [ngClass]="{ 'c-golden-bomb--disabled': !goldenBomb()?.isActive }">
  <div
    class="c-golden-bomb-info"
    [ngClass]="{ 'info-disabled': !goldenBomb()?.isActive }">
    <slotcom-navigation-button
      type="info"
      width="3.55"
      height="3.55"
      topPosition="0.3"
      leftPosition="0.5"
      (click)="openInfo()">
    </slotcom-navigation-button>
  </div>

  <div class="c-golden-bomb-image c-golden-bomb-image--{{ goldenBomb()?.canRedeem ? 'true' : 'false' }}"></div>

  <div class="c-golden-bomb-display">
    <div
      id="loading-bar"
      class="c-golden-bomb-loading-bar"
      [hidden]="!goldenBomb()?.isActive"></div>

    @if (goldenBomb()?.isActive) {
      <div
        data-testid="slotcom-shop-goldenBombValue-display"
        class="c-golden-bomb-display--absolute">
        <div class="img-coin"></div>
        <div
          class="display-text"
          [ngClass]="{
            'display-text-anim': loading()
          }"
          [ngStyle]="{ 'font-size': setFontSize() }">
          {{ currentBonus() | number: '1.0-0' : ('common.culture' | translate) }}
        </div>
      </div>
    }
  </div>

  <slotcom-button
    class="c-button--goldenBomb"
    id="shop-golden-bomb-button"
    data-testid="slotcom-shop-goldenBombValue-redeemButton"
    (safeClick)="redeemGoldenBomb()"
    [isLoading]="loading()">
    {{ 'home.buttons.explode' | translate }}
  </slotcom-button>

  @if (goldenBomb()?.canRedeem && goldenBomb()?.isActive) {
    <div class="c-golden-bomb--is-full"></div>
  }
</div>
